// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"29edc6d9","240":"a20b6512","522":"a5216620","546":"3598bd5a","649":"90ff2fab","660":"a94c4a8d"}[chunkId] + ".chunk.css";
};